import { ON_SAVE_VERIFICATIONS } from "../actions/Verifications";

const initialState = {
  verifications: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ON_SAVE_VERIFICATIONS:
      return {
        ...state,
        verifications: action.payload,
      };
    default:
      return state;
  }
};
export default reducer;
